import { useMemo } from 'react';
import { pluralize } from '@givebutter/util';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { isoDateFromServer } from 'helpers/dates';
import { DateTime } from 'luxon';

const useDaysRemainingOnTrial = () => {
    const { isCurrentlyOnFreeTrial, trialEndsAt } = useCurrentAccount();

    const daysRemainingOnTrial = useMemo(() => {
        if (!isCurrentlyOnFreeTrial || !trialEndsAt) {
            return '';
        }

        const endsAt = isoDateFromServer(trialEndsAt);
        const now = DateTime.now();
        const daysRemaining = Math.ceil(endsAt.diff(now, 'days').days);
        const cappedDaysRemaining = Math.min(daysRemaining, 30);

        return `${cappedDaysRemaining} ${pluralize(cappedDaysRemaining, 'day')}`;
    }, [isCurrentlyOnFreeTrial, trialEndsAt]);

    return daysRemainingOnTrial;
};

export { useDaysRemainingOnTrial };
